/**
 * Image utilities for resolving relative/absolute URLs and handling fallbacks.
 */

export function normalizeImageUrl(url: string | undefined | null, defaultUrl: string): string {
  if (!url) return defaultUrl;
  const trimmed = String(url).trim();
  if (!trimmed) return defaultUrl;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  // Ensure single leading slash when joining with origin
  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return `${window.location.origin}${path}`;
}

/**
 * Returns a reusable onError handler that swaps the src to a default URL on first error,
 * and a compact SVG placeholder on subsequent errors.
 */
export function imageErrorFallback(defaultUrl: string, svgLabel = 'Image') {
  const svg = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='240' viewBox='0 0 400 240' fill='none'%3E%3Crect width='400' height='240' fill='%23f3f4f6'/%3E%3Ctext x='200' y='120' text-anchor='middle' fill='%23666' font-family='sans-serif' font-size='14'%3E${encodeURIComponent(svgLabel)}%3C/text%3E%3C/svg%3E`;
  return (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.target as HTMLImageElement;
    // First fallback to the provided default URL if we're not already using it
    if (target.src !== defaultUrl && !target.src.includes('unsplash')) {
      target.src = defaultUrl;
    } else {
      target.src = svg;
    }
  };
}

export const PLACEHOLDER = {
  avatar:
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='128' height='128' viewBox='0 0 128 128' fill='none'%3E%3Crect width='128' height='128' rx='64' fill='%23f3f4f6'/%3E%3Ccircle cx='64' cy='50' r='20' fill='%239ca3af'/%3E%3Cpath d='M30 108c6-22 23-34 34-34s28 12 34 34' fill='%239ca3af'/%3E%3C/svg%3E",
  thumb:
    'https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=240',
};
